module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"edit_comment_label":"レビュー修正","delete_comment_label":"レビュー削除","delete_comment_confirmation":"コメントを削除しますか？"}}')
  delete Component.options._Ctor
}
